import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

const getCsrfToken = () => {
  // set 'XSRF-TOKEN'
  return Cookies.get("XSRF-TOKEN");
};

const baseQuery = fetchBaseQuery({
  // baseUrl: "http://localhost:3000",
  // baseUrl: "https://prod-api-server-318620872792.us-west1.run.app/",
  baseUrl: "https://prod-board-api-server-318620872792.us-west1.run.app/",

  credentials: "include", // Necessary for cookies to be included
  prepareHeaders: (headers) => {
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      // Set the CSRF token in the request headers
      headers.set("x-csrf-token", csrfToken);
    }
    return headers;
  },
});

export const apiSlice = createApi({
  baseQuery,
  tagTypes: ["User"],
  endpoints: (builder) => ({}),
});
